<script>
  import { Router, Link, Route, link, navigate } from "svelte-routing";
  import { onMount } from "svelte";

  const user = localStorage.getItem("us");

  const API_END_POINT = END_POINT;
  const getorder_details_api_url =
    API_END_POINT + "get_failed_order_details.php";

  let payment_details,
    site_url,
    oid,
    products,
    order_id = "";

  let products_data = [];

  onMount(() => {
    window.scrollTo(0, 0);

    const pathfromurl = window.location.pathname;
    let paths = pathfromurl.split("/");
    order_id = paths[2];

    // console.log(order_id);

    site_url = window.location.protocol + "//" + window.location.host;
    console.log(site_url);

    if (user === null || user === "") {
      navigate("/login");
    }

    get_my_order_details();
  });

  async function get_my_order_details() {
    const get_paymets_failed_response = await fetch(getorder_details_api_url, {
      method: "POST",
      body: JSON.stringify({ uid: user, order_id: order_id }),
    });
    const get_payment_detail_response_data =
      await get_paymets_failed_response.json();
    if (get_payment_detail_response_data != null) {
      payment_details = get_payment_detail_response_data[0];
    }
  }
</script>

<svelte:head>
  <title>Order Details | Veeranfashions Home</title>
</svelte:head>

<main class="main-wrapper">
  <!-- ...:::Start User Event Section:::... -->
  <div class="header-section">
    <div class="container">
      <!-- Start User Event Area -->
      <div class="header-area">
        <div class="header-top-area header-top-area--style-1">
          <ul class="event-list">
            <li class="list-item">
              <span
                onclick="goback()"
                area-label="mobile menu offcanvas svg icon"
                class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow main-menu offcanvas-toggle offside-menu"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-caret-left-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"
                  />
                </svg>
              </span>
            </li>
            <li class="list-item">
              <h6 class="title text-center">Payment Details</h6>
            </li>
            <li class="list-item">
              <ul class="list-child">
                <li class="list-item">
                  <span class="notch-bg" />

                  <Link
                    to="cart"
                    area-label="Cart"
                    class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-cart-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                      />
                    </svg>
                  </Link>
                </li>
                <li class="list-item">
                  <span class="notch-bg" />
                  <Link
                    to="settings"
                    area-label="Cart"
                    class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-person-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                      />
                    </svg>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <!-- End User Event Area -->
    </div>
  </div>
  <!-- ...:::End User Event Section:::... -->

  <!-- ...:::Start Whishlist Section:::... -->
  <div class="cart-section section-gap-top-30">
    <div class="container">
      {#if payment_details}
        <h6 class="text-colored" style="padding-bottom: 15px;">
          Share Us these Details if any Problem Occurs.
        </h6>
        <div class="cart-items-wrapper">
          <!-- Start Single Cart Item -->
          <div class="product-wrapper glass glass_bg">
            <div class="product-wrapper-content--4">
              <!-- Start Product Single Item -->
              <div class="single-product-item product-item--style-4">
                <div class="content">
                  <div class="content--left">
                    <p>Payment Date : <b>{payment_details.payment_time}</b></p>
                    <br />
                    <p>
                      Order ID : <br /><b>{payment_details.response_order_id}</b
                      >
                    </p>
                    <br />
                    <p>
                      Payment ID : <br /><b
                        >{payment_details.response_payment_id}</b
                      >
                    </p>
                    <br />
                    <p>
                      Payment Code : <br /><b>{payment_details.response_code}</b
                      >
                    </p>
                    <br />
                    <p>
                      Payment Description : <br /><b
                        >{payment_details.response_description}</b
                      >
                    </p>
                    <br />
                    <p>
                      Payment Status/Reason : <br /><b
                        >{payment_details.response_reason}</b
                      >
                    </p>
                    <br />
                  </div>
                </div>
                <a href="#?" aria-label="Cart" class="cart-link"
                  ><i class="icon icon-carce-x-circle" /></a
                >
              </div>
              <!-- ENd Product Single Item -->
            </div>
          </div>
        </div>
      {:else}
        <div class="profile-card-section section-gap-top-25">
          <div class="profile-card-wrapper">
            <div class="content">
              <h2 class="setting-name text-white text-center">
                INVALID ORDER ID 💔
              </h2>
            </div>
            <div class="profile-shape profile-shape-1">
              <img
                class="img-fluid"
                src="{site_url}/assets/images/profile-shape-1.svg"
                alt=""
                width="61"
                height="50"
              />
            </div>
            <div class="profile-shape profile-shape-2">
              <img
                class="img-fluid"
                src="{site_url}/assets/images/profile-shape-2.svg"
                alt=""
                width="48"
                height="59"
              />
            </div>
          </div>
        </div>
      {/if}
    </div>
  </div>
  <!-- ...:::End Whishlist Section:::... -->

  <!-- ...:::Start User Event Section:::... -->
  <div class="user-event-section">
    <!-- Start User Event Area -->
    <div class="col pos-relative">
      <div class="user-event-area">
        <div class="nav">
          <Link to="/" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-house-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
              />
              <path
                fill-rule="evenodd"
                d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
              />
            </svg>
            <br />
            <h6>Home</h6>
          </Link>
          <Link to="/wishlist" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-heart-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"
              />
            </svg>
            <br />
            <h6>Wishlist</h6>
          </Link>
          <Link to="/shop" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-grid-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3z"
              />
            </svg>
            <br />
            <h6>Shop</h6>
          </Link>
          
          <Link to="/cart" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-cart-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
              />
            </svg>
            <br />
            <h6>Cart</h6>
          </Link>
          
          <Link to="/settings" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-gear-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"
              />
            </svg>
            <br />
            <h6>Settings</h6>
          </Link>
        </div>
      </div>
    </div>
    <!-- End User Event Area -->
  </div>
  <!-- ...:::End User Event Section:::... -->

  <footer class="footer-section" />
</main>
